export { BugsnagModule } from './src/bugsnag.module';



// WEBPACK FOOTER //
// ./libs/bugsnag/index.ts